import { render, staticRenderFns } from "./Authentications.vue?vue&type=template&id=2d4e39bc&scoped=true"
import script from "./Authentications.vue?vue&type=script&lang=js"
export * from "./Authentications.vue?vue&type=script&lang=js"
import style0 from "./Authentications.vue?vue&type=style&index=0&id=2d4e39bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e39bc",
  null
  
)

export default component.exports